/**
 * Utility per formattare ISO settimana (`YYYY-Www`) con range di date IT.
 *
 * Esempio: '2026-W24' → 'W24 | 8–14 giu' / 'W18 | 27 apr–3 mag'
 */
const MONTHS_IT_SHORT = ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'];
const MONTHS_IT_LONG = ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'];

/** Lunedì→Domenica di una ISO week 'YYYY-Www'. Ritorna [Date(mon), Date(sun)] in UTC. */
export function isoWeekRange(label) {
  if (!label || typeof label !== 'string' || !label.includes('-W')) return null;
  const [yStr, wStr] = label.split('-W');
  const y = Number(yStr);
  const w = Number(wStr);
  if (!Number.isFinite(y) || !Number.isFinite(w)) return null;
  const jan4 = new Date(Date.UTC(y, 0, 4));
  const jan4Day = jan4.getUTCDay() || 7;
  const week1Mon = new Date(jan4);
  week1Mon.setUTCDate(jan4.getUTCDate() - (jan4Day - 1));
  const mon = new Date(week1Mon);
  mon.setUTCDate(week1Mon.getUTCDate() + 7 * (w - 1));
  const sun = new Date(mon);
  sun.setUTCDate(mon.getUTCDate() + 6);
  return [mon, sun];
}

/**
 * Formatta 'YYYY-Www' come 'W24 | 8–14 giu' (default: 'short').
 *
 * @param {string} label es. '2026-W24'
 * @param {{ form?: 'short'|'long', sep?: string }} [opts]
 *   - form: 'short' = 'giu' / 'long' = 'giugno' (default 'short')
 *   - sep: separatore tra W## e range (default ' | ')
 * @returns {string} es. 'W24 | 8–14 giu' o 'W18 | 27 apr–3 mag'
 */
export function formatSettimanaConRange(label, opts = {}) {
  const { form = 'short', sep = ' | ' } = opts;
  const r = isoWeekRange(label);
  if (!r) return label || '';
  const [mon, sun] = r;
  const months = form === 'long' ? MONTHS_IT_LONG : MONTHS_IT_SHORT;
  const wn = label.split('-W')[1];
  const monDay = mon.getUTCDate();
  const sunDay = sun.getUTCDate();
  const monMonth = mon.getUTCMonth();
  const sunMonth = sun.getUTCMonth();
  if (monMonth === sunMonth) {
    return `W${wn}${sep}${monDay}–${sunDay} ${months[sunMonth]}`;
  }
  return `W${wn}${sep}${monDay} ${months[monMonth]}–${sunDay} ${months[sunMonth]}`;
}

/** Solo il range, senza 'W##'. Es. '8–14 giu' */
export function formatRangeSettimana(label, opts = {}) {
  const { form = 'short' } = opts;
  const r = isoWeekRange(label);
  if (!r) return '';
  const [mon, sun] = r;
  const months = form === 'long' ? MONTHS_IT_LONG : MONTHS_IT_SHORT;
  const monDay = mon.getUTCDate();
  const sunDay = sun.getUTCDate();
  const monMonth = mon.getUTCMonth();
  const sunMonth = sun.getUTCMonth();
  if (monMonth === sunMonth) {
    return `${monDay}–${sunDay} ${months[sunMonth]}`;
  }
  return `${monDay} ${months[monMonth]}–${sunDay} ${months[sunMonth]}`;
}
